import "./philosophy.scss";
type PhilosophyPageProps = {};

const PhilosophyPage = (props: PhilosophyPageProps) => {
  return (
    <>
      <div className="philosophy page">
        <div className="philosophy__header page__header">
          <h1 className="philosophy__header__title page__header__title">
            ФИЛОСОФИЯ НА ПРЕПОДАВАНЕ
          </h1>
        </div>
        <div className="philosophy__body">
          <ul className="philosophy__body__content">
            <li className="philosophy__body__content__item">
              <p>
                Обичам професията си и я приемам като мисия – да подкрепям и
                подготвям всеки мой ученик за днес и утре, да откривам
                индивидуалността и талантите , да ръководя всеотдайно първите
                стъпки в училище по пътя на изграждането в успешни личности.
              </p>
            </li>
            <ul className="philosophy__body__content__item__sub-content">
              <li className="philosophy__body__content__item">
                <p>
                  Развивам интелектуалното любопитство, лидерство и
                  сътрудничество между ученици с различен социален, културен,
                  икономически произход.
                </p>
              </li>
              <li className="philosophy__body__content__item">
                <p>
                  Стремя се да давам на учениците си морална опора и доверие в
                  себе си; инциативност и ентусиазъм; възможност за творческа
                  изява; хармонично развитие на волята, мисълта, чувствата и
                  въображението.
                </p>
              </li>
            </ul>
            <li className="philosophy__body__content__item">
              <p>
                Давам на родителите възможност да надхвърлят границите на своя
                мироглед; разнообразие в родителските дейности; сигурен и лоялен
                партньор във възпитанието и обучението на децата.
              </p>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Убедена съм, че никога не е твърде рано или твърде късно да се
                помогне на ученика, да развие умения за успешно учене.
              </p>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Необходима е комбинация от умения - организация, управляване на
                времето, поставяне на приоритети, концентрация и мотивация, за
                да се учи ученикът успешно.
              </p>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Учителят не само преподава, а преди всичко изгражда личности.
              </p>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Преподаването в начален етап е важна и отговорна задача за всеки
                учител. Целта ми е чрез обучението по всички предмети да:
              </p>
              <ul className="philosophy__body__content__item__sub-content">
                <li className="philosophy__body__content__item">
                  <p>
                    формирам у детето комуникативно-речеви умения и знания в
                    различни научни области;
                  </p>
                </li>
                <li className="philosophy__body__content__item">
                  <p>стимулирам силните страни на всеки ученик;</p>
                </li>
                <li className="philosophy__body__content__item">
                  <p>накарам всяко дете да е доволно от постиженията си;</p>
                </li>
                <li className="philosophy__body__content__item">
                  <p>
                    разпознавам, уважавам и поощрявам индивидуалните различия на
                    всеки ученик.
                  </p>
                </li>
              </ul>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Моята философия за обучението е свързана с разбирането ми за
                преподаването като процес , в който същественото е добрият
                контакт с учениците
              </p>
            </li>
            <li className="philosophy__body__content__item">
              <p>
                Когато говорим за дисциплина, въпросът е не как ние да
                контролираме децата, а как да научим децата да контролират себе
                си.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default PhilosophyPage;
